module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('input', {
    ref: "upload",
    attrs: {
      "id": "upload-img"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5284ef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sdUpload.vue
// module id = 871
// module chunks = 1